<template>
  <div>
    <div class="columns toolbar-box action-right">
      <div class="column is-4">
        <h1 class="title is-3 between-center">
                    <span>
                        <span>Proposals by Client Comparison</span>
                    </span>
        </h1>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <o-input v-model="filters.company" @update:modelValue="fetchReportData()" placeholder="Company name" :clearable="true" clearIcon="close-circle" />
        </o-field>
      </div>
      <div class="column is-4-tablet is-2-desktop">
          <o-field>
            <o-select :expanded="true" placeholder="Select Year" v-model="filters.last_year" @update:modelValue="fetchReportData()">
              <option value="">Select Year 1</option>
              <option :value="year" v-for="year in years" v-bind:key="year">
                {{ year }}
              </option>
            </o-select>
          </o-field>
      </div>
      <div class="column is-4-tablet is-2-desktop">
        <o-field>
          <o-select :expanded="true" placeholder="Select Year" v-model="filters.year" @update:modelValue="fetchReportData()">
            <option value="">Select Year 2</option>
            <option :value="year" v-for="year in years" v-bind:key="year">
              {{ year }}
            </option>
          </o-select>
        </o-field>
      </div>
    </div>

    <o-tabs >
      <o-tab-item value="0" label="Proposals">
        <o-table
            table-class="report-table"
            :data="rows_proposals"
            :loading="loading"
            :total="total"
            :per-page="perPage"
            paginated
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @page-change="onPageChange"
            @sort="onSort">
          <template>
            <template>
              <o-table-column
                  #default="{row}"
                  v-for="(col, idx) in columns" :key="idx + '_' + col.field"
                  :field="col.field"
                  :label="col.label"
                  :sortable="col.sortable">
                <span v-if="col.money">{{ $filters.currency(row[col.field]) }}</span>
                <span v-else-if="col.percent">{{ row[col.field] }}%</span>
                <span v-else>{{ row[col.field] }}</span>
              </o-table-column>
            </template>
          </template>
        </o-table>

        <div>Total: <strong>{{ total_proposals }}</strong></div>

      </o-tab-item>

      <o-tab-item :value="1" label="Charge Orders">
        <o-table
            table-class="report-table"
            :data="rows_co"
            :loading="loading"
            :total="total"
            :per-page="perPage"
            paginated
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @page-change="onPageChange"
            @sort="onSort">
          <template>
            <template>
              <o-table-column
                  #default="{row}"
                  v-for="(col, idx) in columns_co" :key="idx + '_' + col.field"
                  :field="col.field"
                  :label="col.label"
                  :sortable="col.sortable">
                <span v-if="col.money">{{ $filters.currency(row[col.field]) }}</span>
                <span v-else-if="col.percent">{{ row[col.field] }}%</span>
                <span v-else>{{ row[col.field] }}</span>
              </o-table-column>
            </template>
          </template>
        </o-table>

        <div>Total: <strong>{{ total_co }}</strong></div>
      </o-tab-item>

    </o-tabs>




  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Table from '../../mixins/Table'
import Datepicker from '../../components/Datepicker'

export default {
  mixins: [Table],

  components: {
    Datepicker
  },

  created () {
    this.filters = {
      year: (new Date).getFullYear(),
      last_year: (new Date).getFullYear() - 1,
      company: ""
    }
  },

  data () {
    return {
      companyId: null,
      contactItem: null,
      currentCompany: null,
      isComponentModalActive: false,
      rows_proposals: [],
      total_proposals: 0,
      rows_co: [],
      total_co: 0,
      loading: false,
      sortField: "name",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      page: 1,
      perPage: 20,
      columns: [],
      columns_co: [],
    }
  },

  methods: {
    fetchReportData()  {
      this.loading = true;
      let params = {year: this.filters.year, last_year: this.filters.last_year, company: this.filters.company}
      axios.get('/api/reports/pending_approved', { params })
          .then(res => {
            this.rows_proposals = res.data.data.proposals;
            this.total_proposals = res.data.data.proposals.length;
            this.rows_co = res.data.data.change_orders;
            this.total_co = res.data.data.change_orders.length;
            this.columns = res.data.data.columns;
            this.columns_co = res.data.data.columns_co;
            this.loading = false;
          })
    },

    onPageChange(p) {
      this.page = p;
      this.fetchReportData();
    },

    onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
    },
  },

  computed: {
    ...mapGetters(['years']),

    ...mapGetters({
      itemsByIds: 'companiesByIds'
    }),

  },

  beforeMount() {
    this.fetchReportData()
  },
}
</script>
